import { useLoaded } from '../lib/useLoaded.ts';
import { LoadingNotice, EmptyNotice, ErrorNotice } from '../components/StateNotice.tsx';
import type { DataPort } from '../adapters/port.ts';

export function DecisionEngine({ port }: { port: DataPort }) {
  const d = useLoaded(() => port.decisions());
  return (
    <section>
      <p className="lede">El motor traduce el pedido en un plan. Cada decisión queda registrada con su regla y su versión.</p>
      {d.kind === 'loading' && <LoadingNotice what="las decisiones" />}
      {d.kind === 'error' && <ErrorNotice message={d.message} />}
      {d.kind === 'empty' && <EmptyNotice what="decisiones registradas" />}
      {d.kind === 'ok' && d.value.map((r) => (
        <article key={r.id} className="decision">
          <header><code>{r.ruleId}</code> <span className="muted">v{r.ruleVersion} · {r.at.slice(0, 10)}</span></header>
          <p><strong>Entrada:</strong> {r.input}</p>
          <p><strong>Resultado:</strong> {r.result}</p>
          <p className="muted">{r.explanation}</p>
          <p className="muted">Override humano: {r.humanOverride ?? 'ninguno'}</p>
        </article>
      ))}
    </section>
  );
}
